import React, { useState } from "react";
import { Redirect } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';

const CandidatesTestsTable = ({ data, isLoading = true }) => {
    const [redirect, setRedirect] = useState(null);

    const handleRowClick = (campaignId) => {
        setRedirect(`/dashboard/campaigns/${campaignId}/candidates`);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const now = new Date();
        const differenceInMinutes = Math.abs(now - date) / (1000 * 60);
        const differenceInHours = differenceInMinutes / 60;
        const differenceInDays = differenceInHours / 24;

        if (differenceInMinutes < 60) {
            return `Il y a ${Math.floor(differenceInMinutes)} minute${Math.floor(differenceInMinutes) > 1 ? 's' : ''}`;
        } else if (differenceInHours < 24) {
            return `Il y a ${Math.floor(differenceInHours)} heure${Math.floor(differenceInHours) > 1 ? 's' : ''}`;
        } else if (differenceInDays < 2) {
            return 'Hier';
        } else {
            return `Le ${date.toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'long'
            })}`;
        }
    };

    if (redirect) return <Redirect to={redirect} />

    if (isLoading) return <div className="column has-text-centered">
        <ProgressSpinner style={{ width: '200px', height: '200px' }} />
    </div>

    return (
        <div className="column">
            <div className="home-candidates-table">
                <table className="table is-fullwidth">
                    <thead>
                        <tr>
                            <th>Campagne</th>
                            <th>Nom</th>
                            <th>Test</th>
                            <th>Score</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody className="is-clickable">
                        {data && data.length > 0 ? (
                            data.map((candidate, index) => (
                                <tr key={index} onClick={() => handleRowClick(candidate.campaign_id)}>
                                    <td>{candidate.campaign_name}</td>
                                    <td>{candidate.first_name} {candidate.last_name}</td>
                                    <td>{candidate.test}</td>
                                    <td>{candidate.score}</td>
                                    <td>{formatDate(candidate.date)}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td className="has-text-centered py-5" colSpan="5">Aucune donnée</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CandidatesTestsTable;